var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavoriteIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4941 0.801034C18.5891 2.02203 20.0631 4.50103 19.9981 7.39303C19.9171 11.003 17.1081 14.187 12.3191 17.031C11.6091 17.453 10.8611 18 10.0001 18C9.15507 18 8.37507 17.443 7.68007 17.03C2.89307 14.187 0.0830677 11.002 0.00206769 7.39303C-0.0629323 4.50103 1.41107 2.02303 3.50607 0.801034C5.46607 -0.339966 7.92807 -0.346966 10.0001 1.33803C12.0721 -0.346966 14.5341 -0.340966 16.4941 0.801034ZM15.4871 2.53003C14.0931 1.71803 12.3511 1.74703 10.8431 3.27303C10.7325 3.384 10.6011 3.47204 10.4565 3.53212C10.3118 3.5922 10.1567 3.62312 10.0001 3.62312C9.84343 3.62312 9.68833 3.5922 9.54367 3.53212C9.399 3.47204 9.26763 3.384 9.15707 3.27303C7.64907 1.74703 5.90707 1.71803 4.51307 2.53003C3.06907 3.37203 1.95307 5.15803 2.00207 7.35003C2.05807 9.86103 4.04207 12.544 8.70207 15.312C9.11007 15.555 9.53607 15.866 10.0001 15.995C10.4641 15.866 10.8901 15.555 11.2981 15.312C15.9581 12.544 17.9421 9.86203 17.9981 7.34903C18.0481 5.15903 16.9311 3.37203 15.4871 2.53003Z",
    fill: "#FFF4E2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteIcon1);
export default __webpack_public_path__ + "static/media/favoriteIcon1.56173692c52b3799205fa1bc944444f3.svg";
export { ForwardRef as ReactComponent };